export default __webpack_public_path__ + "static/station-location-m-52db502e020d459c4afae19baeecb408.jpg";